import { deleteItem, getAllOfflineItems, getItem, updateQueueAfterRequest } from "./offlineQueueFns";
import { OfflineSyncStatus } from "./offlineQueueUtils";
const MAX_RETRIES = 3;

export async function processQueue() {  
  const items = await getAllOfflineItems();
  for (const item of items) {
    if (item.status === OfflineSyncStatus.SUCCESS) continue;

    let retryCount = item.retryCount || 0;
    let success = false;

    while (retryCount < MAX_RETRIES && !success) {
      try {
        success = await processOfflineQueueItem(item, false);
        if (!success) {
          retryCount++;
          if (retryCount >= MAX_RETRIES) {
            await updateQueueAfterRequest(item.id, OfflineSyncStatus.FAILED, retryCount, "Max retries reached", new Date().toISOString())	              
            console.warn(`Max retries reached for item ${item.id}, keeping in DB`);
          } else {
            await updateQueueAfterRequest(item.id, OfflineSyncStatus.RETRYING, retryCount, "Retrying...", new Date().toISOString())	              
            console.warn(`Retry ${retryCount}/${MAX_RETRIES} for item ${item.id}`);
          }
        }
      } catch (err) {
        retryCount++;
        await updateQueueAfterRequest(item.id, OfflineSyncStatus.FAILED, retryCount, err.message || "Unexpected error", new Date().toISOString())          
        console.error(`Error processing item ${item.id}`, err);
        break; // move on to next item/group
      }
    }
  }  
}

export async function processOfflineQueueItem(item, manual) {
  let retryCount = item.retryCount || 0;
  //mark IN_PROGRESS + update lastReqTime
  await updateQueueAfterRequest(item.id, OfflineSyncStatus.IN_PROGRESS, undefined, null, new Date().toISOString())
  try {
    const token = localStorage.getItem("jwt_access_token");
    const res = await fetch(item.url, {
      method: item.method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(item.payload),
    });

    if (!res.ok)
      throw new Error(`HTTP ${res.status}`);
    
    await updateQueueAfterRequest(item.id, OfflineSyncStatus.SUCCESS, undefined, null, new Date().toISOString())			
    // Remove after 30 seconds
    setTimeout(async () => {
      await deleteItem(item.id)						
      console.log(`Removed item ${item.id} from queue after delay`);
    }, 1 * 1000);
      
    return true
  } catch (err) {

    if (!manual) {
      retryCount++;
      await updateQueueAfterRequest(item.id, OfflineSyncStatus.FAILED, retryCount, err.message || "Unknown error", new Date().toISOString())			      
    } else {
      await updateQueueAfterRequest(item.id, OfflineSyncStatus.FAILED, retryCount, err.message || "Retry failed", new Date().toISOString())			      
    }
    return false   
  }
}

export async function retryItem(itemId) {
	const item = await getItem(itemId);
  if (!item) return;
	processOfflineQueueItem(item, true)	
}


export async function deleteRequest(itemId) {
  return await deleteItem(itemId)
}